module.exports = __webpack_public_path__ + "img/va.0e3b3cc.svg";